import React from 'react';
import PropTypes from 'prop-types';
import { CaptionText, Alert } from '@paypalcorp/pp-react';

export default function RecurringInfo({ helpText1, helpText2 }) {
  return (
    <Alert type="info" className="recurring-info">
      <CaptionText
        className="line1"
        dangerouslySetInnerHTML={{ __html: helpText1 }}
      ></CaptionText>
      <CaptionText
        className="line2"
        dangerouslySetInnerHTML={{ __html: helpText2 }}
      ></CaptionText>
    </Alert>
  );
}

RecurringInfo.propTypes = {
  helpText1: PropTypes.string,
  helpText2: PropTypes.string,
};
